export default __webpack_public_path__ + "static/media/3.a8183cd1.jpg";